import * as React from 'react';
import { useTheme } from '@nivo/core'
import { ResponsiveBar } from '@nivo/bar'
import { ResponsiveCalendar } from "@nivo/calendar";

export const Stats: React.FC = () => {
    const data = [
        {
          day: "Monday",
          degress: 59,
          begress: 40
        },
        {
          day: "Tuesday",
          degress: 61,
          begress: 40
        },
        {
          day: "Wednesday",
          degress: 55,
          begress: 40
        },
        {
          day: "Thursday",
          degress: 78,
          begress: 40
        },
        {
          day: "Friday",
          degress: 71,
          begress: 40
        },
        {
          day: "Saturday",
          degress: 56,
          begress: 40
        },
        {
          day: "Sunday",
          degress: 67,
          begress: 40
        }
      ];

    return (
        <React.Fragment>
            <h1>Test</h1>
            <Bar data={data} />
            <div style={{width: "100%", height: "500px"}}>
            <Calendar />
            </div>
        </React.Fragment>
    )
}

interface BarProps {
    data: any
}
const Bar: React.FC<BarProps> = ({data}) => {
    return (
        <div style={{height: "600px", width: "800px"}}>
        <ResponsiveBar
          data={data}
          keys={["degress", "begress"]}
          indexBy="day"
          margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
          padding={0.2}
          valueScale={{ type: "linear" }}
          colors={["#3182CE", "#E53E3E"]}
          animate={true}
          enableLabel={false}
          axisTop={null}
          axisRight={null}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: "degrees",
            legendPosition: "middle",
            legendOffset: -40
          }}
          groupMode="grouped"
        />
        </div>
    );
  };

  const calendarData = [
    {
      value: 290,
      day: "2021-03-03",
    },
    {
      value: 289,
      day: "2021-03-14",
    },
    {
      value: 316,
      day: "2021-04-08",
    },
    {
      value: 297,
      day: "2021-02-10",
    },
    {
      value: 256,
      day: "2021-04-02",
    },
    {
      value: 49,
      day: "2021-07-15",
    },
    {
      value: 374,
      day: "2021-05-11",
    },
    {
      value: 55,
      day: "2021-08-09",
    },
    {
      value: 274,
      day: "2021-05-19",
    },
    {
      value: 20,
      day: "2021-03-28",
    },
    {
      value: 29,
      day: "2021-07-04",
    },
    {
      value: 374,
      day: "2021-01-11",
    },
    {
      value: 377,
      day: "2021-03-27",
    },
    {
      value: 371,
      day: "2021-02-15",
    },
    {
      value: 327,
      day: "2021-05-28",
    },
    {
      value: 289,
      day: "2021-03-12",
    },
    {
      value: 335,
      day: "2021-03-21",
    },
    {
      value: 119,
      day: "2021-06-14",
    },
    {
      value: 369,
      day: "2021-08-04",
    },
    {
      value: 116,
      day: "2021-06-11",
    },
    {
      value: 294,
      day: "2021-04-29",
    },
    {
      value: 381,
      day: "2021-01-23",
    },
    {
      value: 223,
      day: "2021-05-24",
    },
    // More and more pieces of data as the case may be
  ];

  const Calendar: React.FC = () => {
    return (
        <ResponsiveCalendar
        data={calendarData}
        from="2021-01-08"
        to="2021-08-09"
        emptyColor="#eeeeee"
        colors={[
          "#61cdbb",
          "#97e3d5",
          "#e8c1a0",
          "#f47560",
        ]}
        margin={{
          top: 40,
          right: 40,
          bottom: 40,
          left: 40,
        }}
        yearSpacing={40}
        monthBorderColor="#ffffff"
        dayBorderWidth={2}
        dayBorderColor="#ffffff"
        legends={[
          {
            anchor: "bottom-right",
            direction: "row",
            translateY: 36,
            itemCount: 4,
            itemWidth: 42,
            itemHeight: 36,
            itemsSpacing: 14,
            itemDirection: "right-to-left",
          },
        ]}
      />
    )
  }